import {Component, OnInit} from '@angular/core';
import {DirectorSideLegRepurchaseReportService} from '../../../shared/services/director-side-leg-repurchase-report.service';
import {FormBuilder, FormGroup} from '@angular/forms';
import {BsDatepickerConfig} from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-director-side-leg-repurchase-report',
  templateUrl: './director-side-leg-repurchase-report.component.html',
  styleUrls: ['./director-side-leg-repurchase-report.component.scss']
})
export class DirectorSideLegRepurchaseReportComponent implements OnInit {
  submitting = false;
  directorSideLegRepurchaseReport = [];
  slab: any = 0;
  showSearch: any = false;
  searchForm: FormGroup;
  bsConfig: Partial<BsDatepickerConfig>;
  pagination = {
    page: 1,
    total: null,
    perpage: 15,
    pages: null
  };

  constructor(public directorSideLegRepurchaseReportService: DirectorSideLegRepurchaseReportService,
              private fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.refresh();
  }

  refresh() {
    this.searchForm = this.fb.group({
      'director_id': [''],
      'director_level': ['']
    });
    this.get();
  }

  get(params: any = {}) {
    params.page = this.pagination.page;
    params.perpage = this.pagination.perpage;
    this.submitting = true;
    this.directorSideLegRepurchaseReport = [];
    this.directorSideLegRepurchaseReportService.get(params).subscribe(data => {
      if (data && data['data'] && data['data'].length > 0) {
        this.directorSideLegRepurchaseReport = data['data'];
        this.pagination = {
          page: data['pagination'].page,
          total: data['pagination'].total,
          perpage: data['pagination'].perpage,
          pages: data['pagination'].pages,
        };
        this.slab = data.my_slab;
        this.triggerScroll();
      } else {
        this.directorSideLegRepurchaseReport = [];
      }
      this.submitting = false;
    }, error => {
      this.submitting = false;
    });
  }

  triggerScroll() {
    window.scrollTo(500, 500);
    window.scrollTo(500, 0);
  }

  onPageChange(page) {
    this.pagination.page = page;
    this.get();
  }

  search() {
    this.pagination = {
      page: 1,
      total: null,
      perpage: 15,
      pages: null
    };
    let params = {
      'director_id': (this.searchForm && this.searchForm.value) ? this.searchForm.value.director_id : '',
      'director_level': (this.searchForm && this.searchForm.value) ? this.searchForm.value.director_level : ''
    };
    this.get(params);
  }
}
